import { LineThickness } from "frontend/icons/line-thickness";
import { parseStrokeWidth } from "shared/util/utils";
import { ITraits, Trait } from "../elements-toolbar-types";
import { DropdownButton } from "../toolbar-buttons";
import styles from "./shape-stroke-style-picker.module.css";
import { Stack } from "./toolbar-design-system";
import { LineDash } from "./line-dash";
import { LineWidth } from "./line-width-slider";
import { Sizes } from "frontend/data/shapes/sizes";

type ShapeStrokeStyle = Pick<ITraits, "shapeStrokeWidth" | "dash">;

export default function ShapeStrokeStyle({
  value,
  onChange,
}: {
  value: ShapeStrokeStyle[];
  onChange: (trait: Trait, value: any) => void;
}) {
  const shapeSizes = Sizes.get().shape;

  function renderPopup() {
    const widths = new Array(value.length),
      dashes: Record<number, boolean> = {};
    for (let i = 0; i < value.length; i++) {
      widths[i] = value[i].shapeStrokeWidth ? parseStrokeWidth(value[i].shapeStrokeWidth!) : 4;
      dashes[value[i].dash ?? 0] = true;
    }
    return (
      <Stack>
        <LineWidth
          value={widths[0]}
          start={shapeSizes.strokeWidth.start}
          step={shapeSizes.strokeWidth.step}
          count={8}
          onChange={(v) => onChange(Trait.shapeStrokeWidth, v)}
        />
        <LineDash values={dashes} onChange={(v) => onChange(Trait.dash, v)} />
      </Stack>
    );
  }

  return (
    <div>
      <DropdownButton className={styles.popupContainer} tooltip="Stroke style" renderPopup={renderPopup}>
        <LineThickness color="white" size={20} />
      </DropdownButton>
    </div>
  );
}

export function OrgChartNodeStroke({
  values,
  onChange,
}: {
  values: any[];
  onChange: (trait: Trait, value: any) => void;
}) {
  function renderPopup() {
    const widths = new Array(values.length),
      dashes: Record<number, boolean> = {};
    for (let i = 0; i < values.length; i++) {
      widths[i] = values[i].lineWidth;
      dashes[values[i].dash ?? 0] = true;
    }

    return (
      <Stack>
        <LineWidth
          value={widths[0]}
          start={1}
          step={0.2}
          count={8}
          onChange={(v) => onChange(Trait.orgChartNodeStrokeWidth, v)}
        />
        <LineDash values={dashes} onChange={(v) => onChange(Trait.orgChartNodeStrokeDash, v)} />
      </Stack>
    );
  }

  return (
    <DropdownButton className={styles.popupContainer} tooltip="Stroke style" renderPopup={renderPopup}>
      <LineThickness color="white" size={20} />
    </DropdownButton>
  );
}
